import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as actionPicking from '../../../../actions/pickingAction';
import PickingService from '../../../../services/PickingService';
import { Input, Button, Breadcrumbs, ListPaginationNew } from '../../../../components/UI/ComponentsUI';
import { translate, getUrlRepositoryApi, formatData, gerarCSV, isNullOrEmpty } from '../../../../utils/util';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const ListInvoice = (props) => {
    // const [UrlS3] = getUrlLogisticsS3(window);
    const [currentPage, setCurrentPage] = useState(0);
    const [invoices, setInvoices] = useState([]);
    const [filter, setFilter] = useState({
        invoiceNumber: '',
        invoiceKey: ''
    });

    useEffect(() => {
        if (props.invoicesFile?.items?.length > 0) {
            if (invoices.length > 0 && currentPage === 0) {
                setInvoices([...props.invoicesFile.items]);
            } else {
                setInvoices((prevState) => ([...prevState, ...props.invoicesFile.items]));
            }
        } else {
            setInvoices([]);
        }

        // eslint-disable-next-line
    }, [props?.invoicesFile?.items]);

    useEffect(() => {
        onClickButton();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            onClickButton();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onClickButton = (click) => {
        var currentPageList = currentPage;
        if (click) {
            currentPageList = 0;
            setCurrentPage(0);
        }

        props.getInvoicesFile({
            ...filter,
            PageSize: 20,
            PageIndex: currentPageList
        });
    }

    const downloadReport = () => {
        props.getInvoicesFileReport(filter, (response) => {
            gerarCSV('Nota Fiscal', response.items);

        });

    }

    const donwloadImage = (item) => {
        const url = `${getUrlRepositoryApi(window)}/api/repository/file/download?FileName=expedition/notas/${item.fileName}`;
        const tempLink = document.createElement('a');

        tempLink.href = url;
        tempLink.download = item.fileName;
        tempLink.target = "_blank";
        document.body.append(tempLink);
        tempLink.click();
        window.URL.revokeObjectURL(url);
        tempLink.remove();
    }

    const renderItem = (item, index) => {
        return (<>
            <span
                key={index}
                className="title sixth-text-color right"
                style={{ position: 'absolute', marginTop: '5px', right: '30px', zIndex: '999' }}
                onClick={(event) => {
                    event.preventDefault();
                    donwloadImage(item);
                }}
            ><i className='mdi mdi-36px mdi-cloud-download-outline' />
            </span>
            <Link
                key={`link-${index}`}
                className="row"
                style={{ display: 'block', marginBottom: '0px' }}
                to='details'
                onClick={() => {
                    if (props.setInvoiceFile) {
                        props.setInvoiceFile(item);
                    }
                }}
            >
                <span className="title sixth-text-color">{`Número NF: ${item.invoiceNumber || ""}`}</span>
                <span
                    className="truncate second-text-color"
                    style={{ marginLeft: '10px' }}
                >
                    {item.createdBy} - {item.createdByDesc}
                </span>
                <span
                    className="truncate second-text-color"
                    style={{ marginLeft: '10px' }}
                >
                    {formatData(item.createdOn)}
                </span>
                {!isNullOrEmpty(item.orderCode) &&
                    <span
                        className="truncate second-text-color"
                        style={{ marginLeft: '10px' }}
                    >{`Pedido: ${item.orderCode || ""}`}</span>
                }
            </Link>
        </>)
    }

    return (
        <>
            <Breadcrumbs id="pickinginvoice" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('expedition:picking.list-invoice') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className='container'>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div id="formInvoice" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        label={translate('expedition:picking.key-invoice')}
                                        id="invoiceKey"
                                        name="invoiceKey"
                                        type="text"
                                        minLength="44"
                                        maxLength="44"
                                        onChange={onChange}
                                        defaultValue={filter.invoiceKey}

                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        label={'Número Nota Fiscal'}
                                        id="invoiceNumber"
                                        name="invoiceNumber"
                                        type="text"
                                        onChange={onChange}
                                        defaultValue={filter.invoiceNumber}

                                    />
                                </div>
                            </div>
                            <div className="row" style={{ marginTop: '20px' }}>
                                <Button full='true' onClick={() => onClickButton(true)} text={translate('confirm', 'general')} />
                            </div>
                            {
                                invoices.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                                <div className="row" style={{ marginTop: '20px' }}>
                                    <Button onClick={downloadReport} full="true" text="Relatório" />
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <ListPaginationNew
                    page={props.invoicesFile?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={invoices.map((item, index) => (
                        renderItem(item, index)
                    ))}
                />
            </div>

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        invoicesFile: state.pickingReducer.invoicesFile,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoicesFile: (filter, callback) => {
            dispatch(PickingService.getInvoicesFile(filter, callback));
        },
        getInvoicesFileReport: (filter, callback) => {
            dispatch(PickingService.getInvoicesFileReport(filter, callback));
        },
        setInvoiceFile: (invoice) => {
            dispatch(actionPicking.setInvoiceFile(invoice))
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListInvoice)));